import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";

//https://www.pluralsight.com/guides/how-to-pass-data-between-react-components

const RodCut = () => {
	const pageTitle = "Rod Cutting Problem";
	const title = "Rod Cutting Problem";
	const desc =
		"Given a rod of length n inches and an array of prices that includes prices of all pieces of size smaller than n. Determine the maximum value obtainable by cutting up the rod and selling the pieces.";

	useEffect(() => {
		document.title = pageTitle;
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("9"); //int
	const [guiTxt2, guiTxtChange2] = useState("2,4,8,9,10,17,17,20");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	//https://www.geeksforgeeks.org/coin-change-dp-7/
	// function buttonClick1 () {
	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			n = parseInt(guiTxt1);
			values = T.str_toListInt(guiTxt2);
			process();
			BuildResult();
		}
	};

	var txt_time = "";
	var n;
	var values;
	var output;
	var memory = [];

	function process() {
		// output = cut(n);
		memory = [];
		Timer.start();
		output = cut(n, null);
		txt_time = Timer.stop_print();
		console.log("Max " + output.v);
		console.log("Item " + output.items);
		memory = [];
	}

	//int remain
	//best  { v: 0, items: [] };
	function cut(remain, best) {
		if (remain == 1) {
			return { v: values[0], items: [0] };
		}
		if (best == null) {
			//initialize as no cut
			best = { v: 0, items: [] };
		}
		for (var i = 0; i < remain; i++) {
			var j = remain - i - 1;
			// var subBest = cut(j, null);
			//optimize by memory --------
			var subBest;
			if (memory[j] != null) {
				subBest = memory[j];
			} else {
				subBest = cut(j, null);
				memory[j] = subBest;
			}
			//-------------------------
			var newV = values[i] + subBest.v;
			if (newV > best.v) {
				best.v = newV;
				best.items = T.arr_cloneAddFront(subBest.items, i);
			}
		}
		return best;
	}

	// //simple
	// function cut (length)
	// {
	// 	if(length == 0) {return 0;}
	// 	var max = 0;
	// 	for(var c = 0; c < length; c++) {
	// 		var m = cut(c) + values[length - c - 1];
	// 		if(m > max) { max = m; }
	// 	}
	// 	return max;
	// }

	//-------------------------

	function BuildResult() {
		var txt = "";
		var txt2 = "";
		txt2 += "Length : Value"
		for (var i = 0; i < values.length; i++) {
			txt2 += T.str_newline(txt2) + (i + 1) + " : " + values[i];
		}
		var txt = txt_time;
		txt += "\nOptimal Value: " + output.v;
		//
		var freq = T.arr_getFrequency(output.items);
		txt += "\n\nLength : Value x Units"
		for (const [key, v] of Object.entries(freq)) {
			var i = parseInt(key) + 1;
			txt += "\n" + i + " : " + values[key] + " x " + v;
		}

		// txt += "\nHighest frequency: " + result_mostfreq_n;
		partResultChange(
			Template.simple01x2("set1", "Input", txt2, 18, "Result", txt, 18)
		);
	}

	return (
		<GUIset_2Input
			title={title}
			desc={desc}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"Length"}
			label2={"Values"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={true}
			numberOnly2={false}
			txtButton={"Analyze"}
			style={1}
		/>
	);
};
export default RodCut;
